export const INTERACTIVE_CARD_REQUEST_MESSAGE = 'INTERACTIVE_CARD_REQUEST_MESSAGE';